module.exports = __webpack_public_path__ + "static/media/file.686cd2ca.svg";